<template>
    <div style="height: 100%;width: 100%;">
        <!--<van-nav-bar title="我的客人" :placeholder="true" :safe-area-inset-top="false">
            <van-search :value="param" placeholder="请输入搜索关键词"  use-action-slot bind:change="onChange" bind:search="onSearch">
                <view slot="action" bind:tap="onClick">搜索</view>
            </van-search>
        </van-nav-bar>-->
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack" right-text="我的预约" @click-right="openMyOrder"/>
        <el-table height="calc(100% - 2rem)" :data="beautyHeadStaffs" show-header style="width: 100%" ref="beautystaff" class="mytable" @row-click="openMemberInfo">
            <el-table-column prop="membername" align="center" label="姓名"  width="100px">
                <template slot-scope="scope">
                    <div>{{scope.row.membername}}</div>
                    <div>{{scope.row.cardnumber}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="membername" align="center" label="目标" width="50px">
                <template slot-scope="scope">
                    {{scope.row.isenable}}/{{scope.row.iscardchange}}
                </template>
            </el-table-column>
            <el-table-column prop="saledate" align="center" label="最近到店" width="90">
                <template slot-scope="scope">
                    {{$moment(scope.row.saledate).format('MM-DD')}}({{scope.row.iscash}})
                </template>
            </el-table-column>
            <el-table-column prop="lable" align="center" label="预约/拍灯">
                <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-s-custom" size="mini" circle @click.stop="openBeautyLog(scope.row)"></el-button>
                    <el-button type="primary" icon="el-icon-date" size="mini" circle @click.stop="openYy(scope.row)" v-if="scope.row.cardmedium==1"></el-button>
                    <el-button type="danger" icon="el-icon-date" size="mini" circle @click.stop="openYy(scope.row)" v-else></el-button>
                    <el-button type="success" icon="el-icon-s-opportunity" size="mini" v-if="scope.row.iscash<=scope.row.cardnature*0.7" circle @click.stop="getBeautyddTargerById(scope)"></el-button>
                    <el-button type="warning" icon="el-icon-s-opportunity" size="mini" v-else-if="scope.row.iscash<=scope.row.cardnature" circle @click.stop="getBeautyddTargerById(scope)"></el-button>
                    <el-button type="danger" icon="el-icon-s-opportunity" size="mini"  v-else circle @click.stop="getBeautyddTargerById(scope)"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog :title="title" :visible.sync="dialogTableVisible" width="100%">
            <el-input placeholder="请输入内容" v-model="beautyddtarger.targetdd" type="number" clearable></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogTableVisible=false">取消</el-button>
                <el-button type="primary" size="mini" @click="saveBeautyDDTarger()">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                title:this.$moment().format("MM")+"月到店目标次数",
                dialogTableVisible:false,
                param:"",
                beautyHeadStaffs:[],
                storeid:localStorage.getItem("storeid"),
                staffid:"",
                beautyddtarger:{},
                curData:{},
                scrollTop:0,
                path:"",
            }
        },
        activated() {
            //console.log(this.$route.meta.keepAlive);
            
        },
        created: function () {
            this.staffid=this.$route.query.staffid;
            if(!this.staffid){
                this.staffid=localStorage.getItem("staffid");
            }
            //localStorage.setItem("token","eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJBTU4wMDAwNDI3MSIsInN1YiI6IjE1MjAxOTgzNzYzIiwiaWF0IjoxNjQyNzMwMzMzLCJleHAiOjE2NDI4MTY3MzN9._K1bPP6T-z-NSiHeGOZxMWKZfV3c--pZktqkhFxEeRY")
            //localStorage.setItem("storeid","320c07ba76e94b0d8735aefe4470c07a");
            this.getBeautyHeadStaff();
        },
        beforeRouteEnter(to,from,next){
            
                sessionStorage.setItem("beautypath",from.path);
                //console.log(this.scrollTop);
                /*if (from.path == "/beautymemberinfo" || from.path=="/beautyorder" || from.path=="/beautylog" || from.path=="/myorder" || from.path=="/"){
                    to.meta.keepAlive = true;
                }
                else{
                    to.meta.keepAlive = false;
                }*/
                next();
        },
        methods:{
            calScroll(){
                this.scrollTop=sessionStorage.getItem("beautyScrollTop");
                if(this.scrollTop>0) {
                    setTimeout(() => {
                        this.$refs.beautystaff.bodyWrapper.scrollTop = sessionStorage.getItem("beautyScrollTop");
                        console.log(this.scrollTop);
                    }, 100);
                }
            },
            openMyOrder(){
                sessionStorage.setItem("beautyScrollTop",this.$refs.beautystaff.bodyWrapper.scrollTop);
                //this.scrollTop=this.$refs.beautystaff.bodyWrapper.scrollTop;
                this.$router.push({path:"/myorder",query:{
                    staffid:this.staffid
                }});
            },
            openBeautyLog(row){
                sessionStorage.setItem("beautyScrollTop",this.$refs.beautystaff.bodyWrapper.scrollTop);
                //this.scrollTop=this.$refs.beautystaff.bodyWrapper.scrollTop;
                this.$router.push({path:"/beautylog",query:{
                    cardid:row.cardid,
                    cardnumber:row.cardnumber,
                    memberid:row.memberid,
                    sex:row.sex,
                    memberphone:row.memberphone,
                    membername:row.membername,
                    cardtypeid:row.cardtypeid
                }});
            },
            saveBeautyDDTarger(){
                if(this.beautyddtarger.targetdd<1){
                    this.$message.error("请输入正确的到店次数");
                    return;
                }
                let obj=new Object();
                obj.storeid=this.storeid;
                obj.cardid=this.curData.cardid;
                obj.months=this.$moment().format("YYYY-MM");
                obj.targetdd=this.beautyddtarger.targetdd;
                this.$postw("beautymanager/saveBeautyDDTarger",obj).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.dialogTableVisible=false;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getBeautyddTargerById(scope){
                this.curData=scope.row;
                this.$post("beautymanager/getBeautyddTargerById",{storeid:scope.row.storeid,cardid:scope.row.cardid}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null){
                            this.beautyddtarger=obj;
                        }
                        this.dialogTableVisible=true;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            openYy(row){
                sessionStorage.setItem("beautyScrollTop",this.$refs.beautystaff.bodyWrapper.scrollTop);
                //this.scrollTop=this.$refs.beautystaff.bodyWrapper.scrollTop;
                this.$router.push({path:"/beautyorder",query:{
                    cardid:row.cardid,
                    cardnumber:row.cardnumber,
                    memberid:row.memberid,
                    sex:row.sex,
                    memberphone:row.memberphone,
                    membername:row.membername,
                    cardtypeid:row.cardtypeid
                }});
            },
            openMemberInfo(row){
                sessionStorage.setItem("beautyScrollTop",this.$refs.beautystaff.bodyWrapper.scrollTop);
                //this.scrollTop=this.$refs.beautystaff.bodyWrapper.scrollTop;
                //console.log(this.scrollTop);
                this.$router.push({path:"/beautymemberinfo",query:{
                    cardid:row.cardid,
                    cardnumber:row.cardnumber,
                    memberid:row.memberid,
                    membername:row.membername,
                    cardtypeid:row.cardtypeid,
                    sex:row.sex
                }});
            },
            getBeautyHeadStaff(){
                this.$post("beautymanager/getBeautyHeadStaff",{storeid:this.storeid,staffid:this.staffid}).then(res=>{
                    if(res.sucess){
                        this.beautyHeadStaffs=res.object;
                        let path=sessionStorage.getItem("beautypath");
                        if (path == "/beautymemberinfo" || path=="/beautyorder" || path=="/beautylog" || path=="/myorder" || path=="/"){
                            this.calScroll();
                        }                
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
</script>

<style style lang="scss" rel="stylesheet/scss">
    .mytable .el-button+.el-button{
        margin-left:0px;
    }
</style>


// WEBPACK FOOTER //
// src/page/beauty/beautyheadstaff.vue